module.exports = __webpack_public_path__ + "media/img/why/manage-b1f48203e6af6273fb819557f5580f1d.png";